import { Download, X } from "lucide-react";
import { Button } from "@/shared/ui";
import { fmtNum, fmtRubFull } from "@/shared/lib/format";
import type { Placement } from "@/shared/api/wb";

export function ExportModal({ onClose, placements }: { onClose: () => void; placements: Placement[] }) {
  const closed = placements.filter((p) => p.result);
  const totalViews = closed.reduce((s, p) => s + (p.result?.views ?? 0), 0);
  const totalSpent = placements.filter((p) => ["published", "done"].includes(p.status))
    .reduce((s, p) => s + p.price, 0);

  return (
    <div className="fixed inset-0 z-[90] grid place-items-center" style={{ background: "rgba(28,28,28,0.40)", backdropFilter: "blur(4px)" }} onClick={onClose}>
      <div className="w-[480px] bg-white rounded-lg p-6 fade-up shadow-lg" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div>
            <div className="text-[11px] font-display font-semibold uppercase tracking-[0.16em] text-ink-40 mb-1.5">Выгрузка</div>
            <h2 className="font-display font-extrabold text-[20px] tracking-tight">Итоги по кампании</h2>
          </div>
          <button onClick={onClose} className="w-9 h-9 grid place-items-center rounded-md text-ink-60 hover:bg-ink-6"><X size={18} /></button>
        </div>

        <div className="grid grid-cols-3 gap-3 mb-5">
          <Stat l="Закрыто"     v={String(closed.length)} />
          <Stat l="Просмотров"  v={fmtNum(totalViews)} />
          <Stat l="Потрачено"   v={fmtRubFull(totalSpent)} mono />
        </div>

        <div className="grid gap-2">
          <Button><Download size={14} /> XLSX · полный отчёт</Button>
          <Button variant="outline"><Download size={14} /> PDF · краткая выжимка</Button>
          <Button variant="ghost"><Download size={14} /> CSV · сырые данные</Button>
        </div>
      </div>
    </div>
  );
}

function Stat({ l, v, mono }: { l: string; v: string; mono?: boolean }) {
  return (
    <div className="p-3 bg-cream rounded-md text-center">
      <div className="text-[10.5px] uppercase tracking-wider text-ink-40">{l}</div>
      <div className={`font-display font-extrabold text-[18px] mt-1 ${mono ? "font-mono" : ""}`}>{v}</div>
    </div>
  );
}
